/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { getUsers, resendInvite, sendInvite  } from 'state/actions/accountState/account_data';
// component
import Users from 'pages/dashboard/account/users/users';



/* ========== ~~~~~~~~~~ ACCOUNT USERS : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ( { accountData, sessionStatus } ) =>({
    users: accountData.users,
    accountUUID: sessionStatus.accountUUID,
    userUUID: sessionStatus.userUUID,
    // resendingInvite: accountData.resendingInvite,
    sendingInvite: accountData.sendingInvite,
    mocked: sessionStatus.mocked
});

// map actions
const mapDispatchToProps = dispatch => ({
    getUsers: (accountUUID)=> dispatch(getUsers(accountUUID)),
    // resendInvite: (userUUID, isResend) => dispatch(resendInvite(userUUID, isResend)),
    sendInvite: (userUUID) => dispatch(sendInvite(userUUID))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Users);
